import * as React from 'react';
import { Jumbotron } from 'reactstrap';
import { toClass } from 'recompose';
import Alerts from './Alerts';

/** Error page for strava authentication problems */
export default toClass(() => (
    <div className="error-container">
        <Jumbotron>
            <h1 className="text-danger">Error</h1>
            <p className="lead">An error occurred when connecting to strava</p>
        </Jumbotron>
        <Alerts />
    </div>
));



// WEBPACK FOOTER //
// ./src/client/components/ErrorScene.tsx